import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { createQuiz } from '../../control/QuizData';
import { db, auth } from '../../firebase/config';
import { collection, getDocs, query, where, updateDoc } from 'firebase/firestore';
import { onAuthStateChanged } from 'firebase/auth';
import { readRetakeSubmissions } from '../../control/RetakeSubmissionData';

function AddQuiz() {
    const [title, setTitle] = useState("");
    const [link, setLink] = useState("");
    const [course, setCourse] = useState([]);
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [courseNum, setCourseNum] = useState([]);
    const [selectedCourseNum, setSelectedCourseNum] = useState(null);

    const [assignedStudent, setAssignedStudent] = useState([]);
    const [selectedAssignedStudent, setSelectedAssignedStudent] = useState(null);

    const [validated, setValidated] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            const submissions = await readRetakeSubmissions();

            if (user) {
                const classesRef = collection(db, "classes");
                const classSnapshot = await getDocs(classesRef);

                const allClasses = classSnapshot.docs.map(doc => ({
                    ...doc.data(),
                    id: doc.id
                }));

                const myClasses = allClasses
                    .filter(doc => doc.email === user.email)
                    .map(d => ({
                        name: d.name,
                        abbreviatedName: d.abbreviatedName
                    }));

                const uniqueClasses = [...new Set(myClasses.map(d => d.name))];
                setCourse(uniqueClasses);

                if (selectedCourse) {
                    const abbName = myClasses.filter(d => d.name === selectedCourse);
                    setCourseNum(abbName);
                }
            }

            console.log("submissions", submissions);
        });

        return () => unsubscribe();
    }, [selectedCourse]);

    useEffect(() => {
        assignedTo();
    }, [selectedCourseNum]);

    async function assignedTo() {
        const userDocRef = collection(db, "retakeSubmissions");
        const userSnapshot = await getDocs(userDocRef);

        const allUsers = userSnapshot.docs.map(user => ({
            id: user.id,
            ...user.data()
        })).filter(student => student.courseNum === selectedCourseNum);

        const uniqueStudent = [...new Set(allUsers.map(d => d.studentName))];
        setAssignedStudent(uniqueStudent);
    }

    const handleQuizTitle = (e) => {
        setTitle(e.target.value);
    }

    const handlePDFLink = (e) => {
        setLink(e.target.value);
    }

    const handleSubmit = async (event) => {
        const form = event.currentTarget;
        event.preventDefault();

        if (form.checkValidity() === false) {
            event.stopPropagation();
        } else {
            const userQuery = query(
                collection(db, "retakeSubmissions"),
                where("courseNum", "==", selectedCourseNum)
            );

            const snapshot = await getDocs(userQuery);

            for (const doc of snapshot.docs) {
                await updateDoc(doc.ref, { quiz: title });
            }

            await createQuiz(title, link, selectedCourse, selectedAssignedStudent);
        }

        setValidated(true);

        if (form.checkValidity() === true)
            navigate("/faculty/dashboard");
    }

    return (
        <div className="d-flex justify-content-center align-items-center min-vh-100">
            <Container className="centered-form rounded">
                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    <h2 className="text-center my-4">Add Quiz</h2>

                    <Form.Group className="mb-3" controlId="formQuizTitle">
                        <Form.Label>Quiz Title</Form.Label>
                        <Form.Control
                            required
                            type="text"
                            placeholder="Enter quiz title"
                            onChange={handleQuizTitle}
                        />
                        <Form.Control.Feedback type="invalid">
                            Please provide a title.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formQuizPDF">
                        <Form.Label>PDF Link</Form.Label>
                        <Form.Control
                            required
                            type="url"
                            placeholder="Enter link"
                            onChange={handlePDFLink}
                        />
                        <Form.Control.Feedback type="invalid">
                            Please enter a valid link.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formCourse">
                        <Form.Label>Course</Form.Label>
                        <Form.Select
                            required
                            value={selectedCourse}
                            onChange={e => setSelectedCourse(e.target.value)}
                        >
                            <option value="">Select Course</option>
                            {course?.map((course, index) => (
                                <option key={index} value={course}>{course}</option>
                            ))}
                        </Form.Select>

                        <Form.Label className="mt-3">Course Number</Form.Label>
                        <Form.Select
                            required
                            value={selectedCourseNum}
                            onChange={e => setSelectedCourseNum(e.target.value)}
                        >
                            <option value="">Select Course Num</option>
                            {courseNum?.map((num, index) => (
                                <option key={index} value={num.abbreviatedName}>{num.abbreviatedName}</option>
                            ))}
                        </Form.Select>

                        <Form.Label className="mt-3">Assign To</Form.Label>
                        <Form.Select
                            // required
                            value={selectedAssignedStudent}
                            onChange={e => setSelectedAssignedStudent(e.target.value)}
                        >
                            <option value="">Select Student</option>
                            {assignedStudent?.map((student, index) => (     
                                <option key={index} value={student}>{student}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                    
                    <div className="d-flex justify-content-between my-3">
                        <Button variant="success" onClick={() => navigate(-1)}>
                            Back
                        </Button>
                        <Button variant="success" type="submit">
                            Submit
                        </Button>
                    </div>
                </Form>
            </Container>
        </div>
    );
}

export default AddQuiz;
